import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import { Box, Typography, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import { ArticleCardDto } from '../../generated-types/articleCardDto';

/**
 * The article card provides a preview and a link to an article
 * @param props The properties for the article card
 * @returns An article card
 */
const ArticleCard = (props: ArticleCardDto) => {
  const theme = useTheme();

  return (
    <Box
      component={Link}
      to={`/articles/${props.slug}`}
      display="flex"
      marginBottom="2em"
      sx={{
        cursor: 'pointer',
        transition: 'all .2s ease-in-out',
        textDecoration: 'none',
        color: theme.palette.text.primary,
        '&:hover': {
          transform: 'scale(1.02)',
        },
        '&:hover .articleHoverImg': {
          boxShadow: `0px 1.5em 1.5em -20px ${
            theme.palette.mode == 'light' ? 'black' : '#333333'
          }`,
        },
        '&:hover .readArticle': {
          visibility: 'visible',
          opacity: 1,
        },
      }}
    >
      <Box
        className="articleHoverImg"
        width="12em"
        height="6rem"
        marginRight="1em"
        sx={{
          backgroundImage: `url(${props.imageUrl})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          borderRadius: '.4em',
        }}
      />
      <Box
        width="100%"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box>
          <Typography
            variant="h4"
            component="h2"
            fontWeight="bold"
            fontSize="1.5em"
          >
            {props.title}
          </Typography>
          <Typography variant="body1">{props.description}</Typography>
          <Typography variant="caption" fontWeight="600">
            {new Date(props.written).toLocaleDateString('en-us', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          </Typography>
        </Box>
        <Box
          className="readArticle"
          display="flex"
          alignItems="center"
          sx={{
            visibility: 'hidden',
            opacity: 0,
            transition: 'visibility 0.5s, opacity 0.5s ease-in-out',
            marginLeft: '1em',
          }}
        >
          <Typography fontWeight="700">Read</Typography>
          <ArrowForwardIosOutlinedIcon
            sx={{
              marginLeft: '.5em',
              fontSize: '1em',
              visibility: 'none',
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ArticleCard;
